import React from "react";
import { Button } from "react-bootstrap";
import { FaIcon } from "../../../lib/FaIcon";

export const SearchButton = (props) => (
  <Button aria-label="search button" type="submit" variant="secondary" {...props}>
    <FaIcon icon="fa fa-search" align="align-baseline" />
  </Button>
);
